import { makeIGuidePrintSection } from '@apps/i-guide';
import { makePM2PrintFooterSlot, PM2PrintHeaderSlot } from '@provider/print';

const printIGuideComponent = node => {
  return makeIGuidePrintSection(node.component, {
    header: PM2PrintHeaderSlot,
    footer: makePM2PrintFooterSlot("arbejdsark")
  });
};
const iGuideComponentPaperPrinters = {
  "component-framework.i-guide": printIGuideComponent
};

export { iGuideComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
